import CategoryDetail from './CategoryDetail';

export default CategoryDetail;



// WEBPACK FOOTER //
// ./src/scenes/Categories/CategoryDetail/index.ts